"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _AbstractServiceFacade = _interopRequireDefault(require("../AbstractServiceFacade"));

var _ServiceFactory = _interopRequireDefault(require("../ServiceFactory"));

var _LocalizationServiceFacade = _interopRequireDefault(require("./LocalizationServiceFacade"));

var _VpcServiceConfig = _interopRequireDefault(require("../service/vpc/VpcServiceConfig"));

var _LocalizationUtility = _interopRequireDefault(require("../util/LocalizationUtility"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * This class is used as a simple interface for VPC services.
 */
var VpcServiceFacade = /*#__PURE__*/function (_AbstractServiceFacad) {
  _inherits(VpcServiceFacade, _AbstractServiceFacad);

  var _super = _createSuper(VpcServiceFacade);

  function VpcServiceFacade() {
    _classCallCheck(this, VpcServiceFacade);

    return _super.apply(this, arguments);
  }

  _createClass(VpcServiceFacade, null, [{
    key: "saveConfiguration",

    /**
     * Saves a planner configuration.
     *
     * @example VpcServiceFacade.saveConfiguration({ key1: 'value1'}, [ { type: 'ART', id: '123456', qty: 2 } ]).then(() => {
     * // Stored successfully
     * }).catch(error => {
     * // Handle error
     * });
     * @param {object} productConfig Product configuration object.
     * @param {object[]} shoppingList Shopping list.
     * @returns {Promise} Promise object.
     */
    value: function saveConfiguration(productConfig, shoppingList) {
      var _this = this;

      return new Promise(function (resolve, reject) {
        _LocalizationServiceFacade.default.getData().then(function (data) {
          var serviceConfig = _this._getVpcServiceConfig(data);

          _this._getService(serviceConfig).saveConfiguration(serviceConfig, productConfig, shoppingList).then(resolve).catch(_this._clearCacheAndReject.bind(_this, reject));
        }).catch(_this._clearCacheAndReject.bind(_this, reject));
      });
    }
    /**
     * Fetches and returns a planner configuration.
     *
     * @param {string} productConfigId Product configuration id.
     * @param {string[]} [acceptableConfigurationSources] Acceptable configuration sources. Default is "ServiceSettings.applicationName".
     * @returns {Promise} Promise object.
     */

  }, {
    key: "getConfiguration",
    value: function getConfiguration(productConfigId) {
      var _this2 = this;

      var acceptableConfigurationSources = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      return this._getCachePromise(productConfigId) || new Promise(function (resolve, reject) {
        _LocalizationServiceFacade.default.getData().then(function (data) {
          var serviceConfig = _this2._getVpcServiceConfig(data, acceptableConfigurationSources);

          _this2._getService(serviceConfig).getConfiguration(serviceConfig, productConfigId).then(function (configuration) {
            _this2.setCacheItem(productConfigId, configuration);

            resolve(configuration);
          }).catch(_this2._clearCacheAndReject.bind(_this2, reject));
        }).catch(_this2._clearCacheAndReject.bind(_this2, reject));
      });
    }
    /**
     * Fetches and returns a planner configuration.
     *
     * @param {object} localizationData Localisation data.
     * @param {string[]} [acceptableConfigurationSources] Acceptable data sources.
     * @returns {VpcServiceConfig} VPC Service.
     */

  }, {
    key: "_getVpcServiceConfig",
    value: function _getVpcServiceConfig(localizationData) {
      var acceptableConfigurationSources = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var vpcConfig = new _VpcServiceConfig.default();
      vpcConfig.apiLocalePath = localizationData.apiLocalePath;
      vpcConfig.vpcDataSource = _LocalizationUtility.default.getAppSettingValue(localizationData, 'vpcDataSource');
      vpcConfig.endpoints = localizationData.endpoints || {};
      vpcConfig.dexfApiKey = _LocalizationUtility.default.getAppSettingValue(localizationData, 'dexfApiKey');
      vpcConfig.acceptableConfigurationSources = acceptableConfigurationSources;
      return vpcConfig;
    }
    /**
     * Returns the VPC service to use.
     *
     * @param {VpcServiceConfig} serviceConfig VPC service config.
     * @returns {AbstractVpcService} VPC Service.
     */

  }, {
    key: "_getService",
    value: function _getService(serviceConfig) {
      return _ServiceFactory.default.getService(serviceConfig.vpcDataSource === 'DEXF' ? 'dexfvpc' : 'iowsvpc');
    }
    /**
     * Returns cache expire time in ms.
     *  - "0" will disable caching.
     *  - "-1" will cache it the entire session.
     *
     * @override
     * @returns {number} Cache expire time in ms. Returns -1 for article service by default.
     */

  }, {
    key: "cacheExpireTime",
    get: function get() {
      return typeof this._cacheExpireTime === 'number' ? this._cacheExpireTime : -1;
    }
    /**
     * Returns the service name.
     *
     * @override
     * @returns {string} Service name.
     */

  }, {
    key: "serviceName",
    get: function get() {
      return 'VpcServiceFacade';
    }
  }]);

  return VpcServiceFacade;
}(_AbstractServiceFacade.default);

exports.default = VpcServiceFacade;